module.exports = __webpack_public_path__ + "img/forbidden.62afb8a6.svg";